// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconModule = createRemixIcon('IconModule', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M23.255 5.87v-.816l-.746-.328l-10-4.4l-.504-.222l-.503.222l-10 4.4l-.747.328v13.88l.746.33l10 4.41l.504.222l.504-.223l10-4.41l.746-.328zm-10 4.956l7.5-3.307v9.786l-7.5 3.307zm-2.5 0l-7.5-3.307v9.786l7.5 3.307z\" clip-rule=\"evenodd\"/>");
